// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wG87e","type":"styles_type__32zha","choices":"styles_choices__3Vfv8"};